/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductCatalogueResponse } from './ProductCatalogueResponse';
import {
    ProductCatalogueResponseFromJSON,
    ProductCatalogueResponseFromJSONTyped,
    ProductCatalogueResponseToJSON,
    ProductCatalogueResponseToJSONTyped,
} from './ProductCatalogueResponse';

/**
 * Contains the result of the database fetch from Service Definition table
 * @export
 * @interface ProductCatalogueListResult
 */
export interface ProductCatalogueListResult {
    /**
     * Products data that can be shown to the user
     * @type {Array<ProductCatalogueResponse>}
     * @memberof ProductCatalogueListResult
     */
    products?: Array<ProductCatalogueResponse>;
}

/**
 * Check if a given object implements the ProductCatalogueListResult interface.
 */
export function instanceOfProductCatalogueListResult(value: object): value is ProductCatalogueListResult {
    return true;
}

export function ProductCatalogueListResultFromJSON(json: any): ProductCatalogueListResult {
    return ProductCatalogueListResultFromJSONTyped(json, false);
}

export function ProductCatalogueListResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductCatalogueListResult {
    if (json == null) {
        return json;
    }
    return {
        
        'products': json['products'] == null ? undefined : ((json['products'] as Array<any>).map(ProductCatalogueResponseFromJSON)),
    };
}

export function ProductCatalogueListResultToJSON(json: any): ProductCatalogueListResult {
    return ProductCatalogueListResultToJSONTyped(json, false);
}

export function ProductCatalogueListResultToJSONTyped(value?: ProductCatalogueListResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'products': value['products'] == null ? undefined : ((value['products'] as Array<any>).map(ProductCatalogueResponseToJSON)),
    };
}

